export enum TimeRegistrationNotAllowedReason {
	NoProject = 'NO_PROJECT',
	NoInternalTime = 'NO_INTERNAL_TIME',
	NoDoneTask = 'NO_DONE_TASK',
	NoUnassignedTask = 'NO_UNASSIGNED_TASK',
}

export function getNotAllowedReasonEntityLabel(notAllowedReason: TimeRegistrationNotAllowedReason): string {
	switch (notAllowedReason) {
		case TimeRegistrationNotAllowedReason.NoProject:
			return 'directly on projects';
		case TimeRegistrationNotAllowedReason.NoInternalTime:
			return 'on internal time';
		case TimeRegistrationNotAllowedReason.NoDoneTask:
			return 'on done tasks';
		case TimeRegistrationNotAllowedReason.NoUnassignedTask:
			return 'on tasks that are not assigned to you';
	}
}
